import OtpPage from "./OtpPage";
import { useAuth } from "./AuthContext";

const SignUpVerifyPage = () => {
  const { verifyRegister } = useAuth();
  return <OtpPage title="ثبت نام" verify={verifyRegister} />;
};

export default SignUpVerifyPage;
